/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The QuestionnairesidquestionsquestionIdQuestionnaire model module.
 * @module model/QuestionnairesidquestionsquestionIdQuestionnaire
 * @version v0.3
 */
export default class QuestionnairesidquestionsquestionIdQuestionnaire {
  /**
   * Constructs a new <code>QuestionnairesidquestionsquestionIdQuestionnaire</code>.
   * @alias module:model/QuestionnairesidquestionsquestionIdQuestionnaire
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>QuestionnairesidquestionsquestionIdQuestionnaire</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/QuestionnairesidquestionsquestionIdQuestionnaire} obj Optional instance to populate.
   * @return {module:model/QuestionnairesidquestionsquestionIdQuestionnaire} The populated <code>QuestionnairesidquestionsquestionIdQuestionnaire</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new QuestionnairesidquestionsquestionIdQuestionnaire();
      if (data.hasOwnProperty('questionnaire'))
        obj.questionnaire = ApiClient.convertToType(data['questionnaire'], Object);
    }
    return obj;
  }
}

/**
 * @member {Object} questionnaire
 */
QuestionnairesidquestionsquestionIdQuestionnaire.prototype.questionnaire = undefined;

